<script>
import {mapMutations, mapState} from "vuex";
import TriviaService from "@/api/services/triviaService";
import {mtnServiceIdMap} from "@/config";

export default {
  name: "BonusRoundView",
  computed: {
    ...mapState(['user', 'userQuestions', 'productId', 'token']),
  },
  methods: {
    ...mapMutations(['setQuestionCategoryId', 'setGameState', 'setDisplayBonusRoundPop', 'setCategoryGameState']),
    async letsDoItClicked() {
      await this.startGame();
      this.setQuestionCategoryId(null);
      this.$router.push('/game-play')
    },
    getServiceIdMapNumber(service) {
      return mtnServiceIdMap.get(service);
    },
    async startGame() {
      await TriviaService.startGame(this.user.msisdn, this.userQuestions.gameId, 1);
    },
    async notTodayClicked() {
      const recordsets = await TriviaService.endGame(this.userQuestions.gameId, 1);
      const firstRow = recordsets?.[0]?.[0];
      if (firstRow) await this.addUserFunds(firstRow);

      return this.$router.push({name: 'BonusEndScreen'});
    },
    async upsertGameState() {
      const recordsets = await this.getGameState();
      const firstRecordset = recordsets?.[0] ?? [];
      if (firstRecordset.length > 0) this.setGameState(firstRecordset[0]);
      if (recordsets?.length > 1) this.setCategoryGameState(recordsets[1])
    },
    async addUserFunds(fundsRow) {
      await TriviaService.addFunds(this.user.msisdn, this.productId, fundsRow.GameFundsTypeId, fundsRow.GameFundsAllocationTypeId, fundsRow.Value, fundsRow.FromGameId);
    },
    async getGameState() {
      return await TriviaService.getGameState(this.user.msisdn, this.user.serviceId);
    }
  }
}
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 bonus-container">
    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <img src="@/assets/bonusRound/bonus-img.png" class="col-6"/>
    </div>
    <div class="text-center heading mt-3">Bonus Round</div>
    <div class="text-center secondHeading">Press “Play” to start</div>

    <div class="text-center normalText mt-5">You’ll have <span class="bold mx-1">10 seconds</span>
      to answer the bonus
    </div>
    <div class="text-center normalText ">question. Answer correctly for a chance
      to
    </div>
    <div class="text-center normalText "><span class="bold">double</span> your
      coins.
    </div>

    <div class="text-center normalText mt-3">But be careful, a wrong answer</div>
    <div class="text-center normalText ">will <span class="bold mx-1">halve</span>
      coins.
    </div>

    <div class=" d-flex flex-column justify-content-center align-items-center col-12 mt-5">
      <div @click="letsDoItClicked()" class="playButton text-center playText p-4 col-11">Play</div>
    </div>
    <div @click="notTodayClicked()" class="d-flex justify-content-center align-items-center returnText mt-3">Return
      Home
    </div>
  </div>


</template>

<style scoped>

.bonus-container {
  background: rgba(0, 0, 21, 0.86);
  backdrop-filter: blur(5px);
  min-height: 100vh;

}

.normalText {
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF
}

.heading {
  font-weight: 600;
  font-size: 33px;
  color: #FFFFFF;
}

.secondHeading {
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
}

.playButton {
  background-color: #FFCB05;
  border-radius: 29px;
}

.playText {
  font-weight: 600;
  font-size: 18px;
}

.returnText {
  font-weight: 600;
  font-size: 17px;
  text-decoration: underline;
  color: #FFFFFF;
}

.bold {
  font-weight: 700;
  color: #FFFFFF
}

</style>